import IconWeight from "assets/img/icon-weight.svg?react"
import IconDimensions from "assets/img/icon-dimensions.svg?react"
import IconVolume from "assets/img/icon-volume.svg?react"

import { FC } from "react"
import { useTranslation } from "react-i18next"

import { Flex } from "components/Flex"
import { Grid } from "components/Grid"
import NoValue from "components/NoValue/NoValue"
import { Guid } from "@/types"
import { formatNumber } from "utils/utils"
import { useUnits } from "stores/units"

interface IMeasurementsProps {
    measurementSystemId?: Guid | null
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    volume?: number | null
    weight?: number | null
}

const Measurements: FC<IMeasurementsProps> = ({
    measurementSystemId,
    dimension1,
    dimension2,
    dimension3,
    volume,
    weight,
}) => {
    const { t } = useTranslation()
    const { getUnit } = useUnits()
    const unit = getUnit(measurementSystemId ?? undefined)
    const unitLabel = unit?.printShort() || ""

    const dimensions = [
        typeof dimension1 === "number" ? `${t('common.dimensionShort.length')} ${formatNumber(dimension1)} ${unitLabel}` : null,
        typeof dimension2 === "number" ? `${t('common.dimensionShort.width')} ${formatNumber(dimension2)} ${unitLabel}` : null,
        typeof dimension3 === "number" ? `${t('common.dimensionShort.height')} ${formatNumber(dimension3)} ${unitLabel}` : null,
    ].filter(d => !!d)

    return (
        <Flex wrap="wrap" alignContent="center">
            <Grid columns="max-content minmax(0, auto)" gap="0.4rem" alignItems="center">
                <IconWeight />
                {typeof weight === "number"
                    ? `${weight} ${t('common.kg')}`
                    : <NoValue />
                }
            </Grid>
            <div className="px-1">|</div>
            <Grid columns="max-content minmax(0, auto)" gap="0.4rem" alignItems="center">
                <IconDimensions />
                {dimensions.length > 0
                    ? dimensions.join(" x ")
                    : <NoValue />
                }
            </Grid>
            <div className="px-1">|</div>
            <Grid columns="max-content minmax(0, auto)" gap="0.4rem" alignItems="center">
                <IconVolume />
                {typeof volume === "number"
                    ? `${volume} ${t('common.m3')}`
                    : <NoValue />
                }
            </Grid>
        </Flex>
    )
}

export default Measurements
